import { ApiClient } from "./ApiClient";
import { RealmLower } from "../constants";
import { JSONObject, CustomerData, CustomerDataHistory, ServiceResult } from "./index";
import { toErrorMessage } from "../utils/ErrorMessage";

interface AggregatedResponse {
  registrationFormData: JSONObject | null;
  registrationFormDataHistory?: JSONObject[];
  abRegistration: JSONObject | null;
  abRegistrationHistory?: JSONObject[];
  registrationRequest: JSONObject | null;
  registrationRequestHistory?: JSONObject[];
  abGuestAccounts: JSONObject | null;
  abGuestAccountsHistory?: JSONObject[];
}

export interface AggregatedCustomerData {
  data: CustomerData;
  history: CustomerDataHistory | null;
}

export class AggregatedCustomerDataService {
  private api: ApiClient;

  constructor(api: ApiClient = ApiClient.getInstance()) {
    this.api = api;
  }

  async fetchAll(realm: RealmLower, customerId: string, includeHistory: boolean): Promise<ServiceResult<AggregatedCustomerData>> {
    try {
      const base = this.api.getBaseUrl("customer-data", realm);
      const region = this.api.getRegionCode(realm);
      const url = `${base}/customer-data?id=${customerId}&region=${region}&includeHistory=${includeHistory}`;
      const response = await this.api.get<AggregatedResponse>(url);

      const data: CustomerData = {
        "rfd": response.registrationFormData,
        "registration-request": response.registrationRequest,
        "ab-registration": response.abRegistration,
        "ab-guest": response.abGuestAccounts,
      };

      const history: CustomerDataHistory | null = includeHistory
        ? {
            "rfd": response.registrationFormDataHistory || [],
            "registration-request": response.registrationRequestHistory || [],
            "ab-registration": response.abRegistrationHistory || [],
            "ab-guest": response.abGuestAccountsHistory || [],
          }
        : null;

      return { status: "ok", data: { data, history } };
    } catch (err) {
      return { status: "error", message: toErrorMessage(err) };
    }
  }
}
